import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const incomeSectionComponent = {
  amount: 'income-section.amount',
  editLink: 'income-section.edit-link',
  frequency: 'income-section.frequency',
  h3: 'income-section.h3',
  incomeType: 'income-section.income-type',
  root: 'income-section.root',
  status: 'income-section.status',
} as const satisfies ComponentLocatorMap;
